import React from 'react'
import { isEmpty } from 'libraries/lodash'
import Grid from '@mui/material/Grid'
import { AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import { getDescendants, getUniquelyTitledDescendants } from 'services/QAService'
import Tile from './Tile'

const QaTiledMenu = ({ tiledMenu, dataHelpItem, ignoreNodes = false, aols, ...props }) => {
  const { topLevelSections, nodes } = tiledMenu

  if (isEmpty(topLevelSections) || (!ignoreNodes && isEmpty(nodes))) {
    return null
  }

  const safeKeyword = props.keyword.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(safeKeyword, 'i')

  const renderedTiles = topLevelSections.reduce((acc, tile, index) => {
    if (!tile.active) return acc
    if (props.showFavouritesOnly && !(props.favourites || []).includes(tile.id)) {
      return acc
    }
    const descendants = safeKeyword.length > 0
      ? getDescendants(nodes, tile.id, props.flavour, tile.areaOfLaw)
      : []
    const matchingDescendants = descendants.filter(obj => regex.test(obj.title))
    if (safeKeyword.length > 0 && matchingDescendants.length === 0) { return acc }
    const uniquelyTitledDecendants = getUniquelyTitledDescendants(nodes, matchingDescendants, tile.id)

    return [
      ...acc,
      (
        <Grid key={index} item xs={12} sm={4} md={3} lg={2}>
          <Tile
            {...{
              nodes,
              ...tile,
              ...props,
              keyword: props.keyword,
              matchingDescendants: uniquelyTitledDecendants,
              aol: tile.areaOfLaw,
              restricted: (tile.descendants || []).some(descendantId =>
                nodes[descendantId] && nodes[descendantId].currentUserCanAccessSection === false
              )
            }}
          />
        </Grid>
      )
    ]
  }, [])

  return (
    <nav>
      {topLevelSections.length > 0 && renderedTiles.length > 0 && (
        <div className='tile-container' data-help-item={dataHelpItem} data-help-position='middle'>
          <Grid container spacing={2}>
            {renderedTiles}
          </Grid>
        </div>
      )}
      {renderedTiles.length === 0 && (
        <p className='f3 tc i'>
          {safeKeyword.length > 0 ? `No results for keyword "${props.keyword}"` : 'No favourites selected'} in {AOL_DISPLAY_NAMES[aols[0]]}
        </p>
      )}
    </nav>
  )
}

export default QaTiledMenu
